export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  ENDPOINTS: {
    LOGOUT: '/logout',
    CITY:'/api/cities/',
    DEPARTMENT:'/api/departments/by-city/',
    USERS:'/api/users/by-city-department/',
    TASKS:'/api/tasks/search/',
    TASK_STATUS:'/api/task_status/',
    TASK_TYPES:'/api/task_types/',
    TASK_PRIORITIES:'/api/task_priorities',
    CREATE_TASK:'/api/tasks/',
    VALIDATE_TOKEN:'/validate_token',
    USER_PROFILE:'/user_profile',
    EMPLOYEE_TASKS:'/api/tasks/user/',
    DEPARTMENT_TASKS:'/api/tasks/department/',
    TASK_DETAIL:'/api/tasks/',
    LOGIN:'/login',
    REQUEREMENTS:'/api/requirements-incidents/',
    CRITICICALITIES:'/api/criticalities/',
    CRITICALITY_CREATE:'/api/criticalities/',
    CRITICALITY_UPDATE:'/api/criticalities/',
    CRITICALITY_DELETE:'/api/criticalities/',
    REQUIREMENT_CREATE:'/api/requirements-incidents/',
    REQUIREMENT_UPDATE:'/api/requirements-incidents/',
    REQUIREMENT_DELETE:'/api/requirements-incidents/',
    ARRANDA_INTERNAL_DETAILS_LIST:'/api/arranda-ticket-internal-details/',
    ARRANDA_INTERNAL_DETAILS_CREATE:'/api/arranda-ticket-internal-details/',
    ARRANDA_INTERNAL_DETAILS_UPDATE:'/api/arranda-ticket-internal-details/',
    ARRANDA_INTERNAL_DETAILS_DELETE:'/api/arranda-ticket-internal-details/',
    TASK_FILES:'/api/task_files/',
    SEND_EMAIL:'/api/email/send_email',
    SEND_SURVEY_NOTIFICATION:'/api/email/send_survey_notification',
    SUB_AREAS:'/api/sub-areas/by-city-area/',
    USERS_BY_SUBAREA:'/api/tasks/user/',
    RESET_PASSWORD_WITH_TOKEN:'/api/survey-manager/reset-password-with-token',
    /** Completadas (tasks) del responsable sin task_followups con estado 11 (hoja enviada) */
    PARENT_TASKS_MISSING_HOJA_SERVICIO: '/api/tasks/parent-tasks-missing-hoja-servicio',
    /** Solo contador (ligero) para badge sin cargar lista ni enriquecer */
    PARENT_TASKS_MISSING_HOJA_SERVICIO_COUNT: '/api/tasks/parent-tasks-missing-hoja-servicio/count',
    TASK_BY_ID:'/api/tasks/',
    TASK_SUBTASKS:'/api/tasks/',
    /** PATCH .../api/tasks/{id}/contract-service — body { contract_id, service_id } */
    TASK_PATCH_CONTRACT_SERVICE: '/api/tasks/',
    /** Informe tiempos + seguimientos: GET .../api/tasks/{id}/attendance-report */
    TASK_ATTENDANCE_REPORT:'/api/tasks/',
    TASK_RESOLVE_HIERARCHY_REF:'/api/tasks/resolve-hierarchy-ref/',
    TASK_BY_ARRANDA:'/api/tasks/arranda/',
    TASKS_DATE_RANGE:'/api/tasks/date-range',
    /** Informe asistencia listado: GET con query start_date, end_date, limit, offset */
    TASKS_ATTENDANCE_REPORT_LIST: '/api/tasks/attendance-report',
    /** Abiertas en todas las áreas (excl. completadas/canceladas) */
    TASKS_OPEN_ALL_AREAS:'/api/tasks/list/open-all-areas',
    /** Completadas/finalizadas por mes (alias backend: /stats/completed-by-month) */
    TASKS_COMPLETED_BY_MONTH:'/api/tasks/stats/completed-finalized',
    /** Tiempo en Ejecución del usuario en sesión, por mes calendario */
    TASKS_MONTHLY_EXECUTION_TIME: '/api/tasks/user/me/monthly-execution-time',
    TASKS_ALL_BY_USER:'/api/tasks/all/',
    GENERATE_TOKEN:'/api/survey-manager/generate-token',
    GENERATE_PASSWORD_RESET_TOKEN:'/api/survey-manager/generate-password-reset-token',
    TASKS_BY_USER:'/api/tasks/user/',
    TASKS_BY_USER_TASKS:'/api/tasks/user/',
    AREAS_BY_CITY:'/api/areas/by-city/',
    USERS_BY_CITY_AREA:'/api/users/by-city-area/',
    SUB_AREAS_BY_CITY:'/api/sub_areas/by-city/',
    /** GET ?city_id=&scope_sub_area_id= — subáreas asignadas en users (filtro Soporte) */
    SUB_AREAS_FOR_ASSIGNEE_FILTER: '/api/sub_areas/for-assignee-filter',
    SUB_AREAS_BY_CITY_AREA:'/api/sub_areas/by-city-area/',
    USERS_BY_CITY_AREA_SUBAREA:'/api/users/by-city-area-subarea/',
    TASK_FOLLOWUPS:'/api/task_followups/',
    TASK_FOLLOWUPS_BY_TASK:'/api/task_followups/task/',
    /** Observaciones / seguimiento (tabla task_observations) */
    TASK_OBSERVATIONS: '/api/task_observations/',
    TASK_OBSERVATIONS_BY_TASK: '/api/task_observations/task/',
    TASK_OBSERVATION_BY_ID: '/api/task_observations/',
    /** PUT .../id/mark-read */
    TASK_OBSERVATION_MARK_READ: '/api/task_observations/',
    /** PUT .../task/{id}/mark-all-read */
    TASK_OBSERVATIONS_MARK_ALL_READ: '/api/task_observations/task/',
    /** POST body { task_ids: number[] } — conteos no leídos por tarea (badges) */
    TASK_OBSERVATIONS_UNREAD_COUNTS: '/api/task_observations/unread-counts',
    TASK_FILES_BY_TASK:'/api/task_files/task/',
    TASKS_SEARCH_ARRANDA:'/api/tasks/search/arranda',
    TASKS_SEARCH_INTERNAL_DETAILS:'/api/tasks/search/internal-details',
    TASKS_BY_CONTRACT_SERVICE:'/api/tasks/contract/',
    TASKS_BY_CLIENT_CONTRACT_FULL:'/api/tasks/client/',
    SERVICE_TICKETS:'/api/service-tickets/',
    SERVICE_TICKETS_FILTER: '/api/service-tickets/filter',
    /** GET query: contract_version (código canónico SEC.157800.C / DCC92), service_type + frequency (bolsa horas) */
    SERVICE_TICKETS_BALANCE_WORK_MINUTES: '/api/service-tickets/balance-work-minutes',
    SERVICE_TICKETS_BULK_UPDATE:'/api/service-tickets/bulk-update-client',
    /** PUT — actualiza requested_by (Solicitado por) en varias tareas históricas con el mismo nombre */
    SERVICE_TICKETS_BULK_UPDATE_REQUESTED_BY:'/api/service-tickets/bulk-update-requested-by',
    /** PATCH /api/service-tickets/:id/contract-number — solo contract_number de un ticket histórico */
    SERVICE_TICKET_PATCH_CONTRACT_NUMBER: '/api/service-tickets/',
    /** PATCH /api/service-tickets/:id/requested-service — solo requested_service de un ticket histórico */
    SERVICE_TICKET_PATCH_REQUESTED_SERVICE: '/api/service-tickets/',
    SURVEYS_ALL_RESPONSES:'/api/survey-manager/surveys/all_responses_full',
    SURVEY_RATINGS_BY_CLIENT_CONTRACT:'/api/survey-manager/surveys/ratings_by_client_contract',
    SURVEY_RATINGS_BY_JOURNEY:'/api/survey-manager/surveys/ratings_by_journey',
    SURVEY_SUPPORT_RATINGS_BY_EMPRESA:'/api/survey-manager/surveys/support_ratings_by_empresa',
    SURVEY_QUESTIONS:'/api/survey-manager/questions',
    SURVEY_QUESTIONS_BY_TASK:'/api/survey/questions',
    SURVEY_SUBMIT:'/api/survey/submit',
    SURVEY_MANAGER:'/api/survey-manager',
    JOURNEY_EXPERIENCE_ENCUESTAS: '/api/journey-experience/encuestas',
    JOURNEY_EXPERIENCE_RESUMEN: '/api/journey-experience/resumen',
    JOURNEY_EXPERIENCE_GESTIONADO: '/api/journey-experience/encuestas',
    JOURNEY_SUMMARY: '/api/journey-experience/summary',
    JOURNEY_RESPONSES: '/api/journey-experience/responses',
    JOURNEY_ALERTS: '/api/journey-experience/alerts',
    JOURNEY_EMPLOYEES: '/api/journey-experience/employees',
    JOURNEY_TRIGGERS: '/api/journey-experience/triggers',
    JOURNEY_RESPONSE_PATCH: '/api/journey-experience/responses',
    PUBLIC_SURVEY: '/api/public/survey',
    // Customer Journey Endpoints
    CUSTOMER_JOURNEY_ALL: '/api/customer-journey/',
    CUSTOMER_JOURNEY_BY_ID: '/api/customer-journey/',
    CUSTOMER_JOURNEY_CREATE: '/api/customer-journey/',
    CUSTOMER_JOURNEY_UPDATE: '/api/customer-journey/',
    CUSTOMER_JOURNEY_UPLOAD_FILES: '/api/customer-journey/',
    CUSTOMER_JOURNEY_DELETE_FILE: '/api/customer-journey/',
    CUSTOMER_JOURNEY_DELETE: '/api/customer-journey/',
    CUSTOMER_JOURNEY_EVENTS: '/api/customer-journey/',
    CUSTOMER_JOURNEY_EVENT_CREATE: '/api/customer-journey/',
    CUSTOMER_JOURNEY_SUPPORT_TASKS: '/api/customer-journey/',
    CUSTOMER_JOURNEY_MANUAL_FOLLOWUPS: '/api/customer-journey/',
    CUSTOMER_JOURNEY_MANUAL_FOLLOWUPS_CREATE: '/api/customer-journey/',
    CUSTOMER_JOURNEY_SURVEYS: '/api/customer-journey/',
    CUSTOMER_JOURNEY_SURVEY_OPTIONS: '/api/customer-journey/survey-options',
    CUSTOMER_JOURNEY_PHASE_SURVEY_TEMPLATES: '/api/customer-journey/phase-survey-templates',
    CUSTOMER_JOURNEY_PHASE_SURVEY_STANDARD: '/api/customer-journey/phase-survey-templates/standard',
    CUSTOMER_JOURNEY_PHASE_SURVEY_RESOLVE: '/api/customer-journey/phase-survey-templates/resolve',
    CUSTOMER_JOURNEY_PHASE_EMAIL_STANDARD: '/api/customer-journey/phase-email-templates/standard',
    CUSTOMER_JOURNEY_PHASE_EMAIL_PREVIEW: '/api/customer-journey/phase-email-templates/preview',
    CUSTOMER_JOURNEY_PHASE_EMAIL_TEST: '/api/customer-journey/phase-email-templates/test-send',
    CUSTOMER_JOURNEY_EMAIL_SEND_LOGS: '/api/customer-journey/email-send-logs',
    CUSTOMER_JOURNEY_SURVEY_CREATE: '/api/customer-journey/',
    CUSTOMER_JOURNEY_SIMULATE_PHASE_EMAILS: '/api/customer-journey/',
    CUSTOMER_JOURNEY_TOKEN_GENERATE: '/api/customer-journey/survey-tokens/generate',
    CUSTOMER_JOURNEY_SURVEY_TOKENS_PENDING: '/api/customer-journey/survey-tokens/pending',
    CUSTOMER_JOURNEY_SURVEY_SCHEDULE: '/api/customer-journey/survey-tokens/schedule',
    CUSTOMER_JOURNEY_TOKEN_VALIDATE: '/api/customer-journey/survey-tokens/validate',
    CUSTOMER_JOURNEY_TOKEN_MARK_USED: '/api/customer-journey/survey-tokens/mark-used',
    CUSTOMER_JOURNEY_TOKEN_SUBMIT: '/api/customer-journey/survey-tokens/submit',
    CUSTOMER_JOURNEY_SURVEY_OPTIONS: '/api/customer-journey/survey-options',
    CUSTOMER_JOURNEY_PHASE_SURVEY_TEMPLATES: '/api/customer-journey/phase-survey-templates',
    CUSTOMER_JOURNEY_PHASE_SURVEY_STANDARD: '/api/customer-journey/phase-survey-templates/standard',
    CUSTOMER_JOURNEY_PHASE_SURVEY_RESOLVE: '/api/customer-journey/phase-survey-templates/resolve',
    CUSTOMER_JOURNEY_PHASE_EMAIL_STANDARD: '/api/customer-journey/phase-email-templates/standard',
    CUSTOMER_JOURNEY_PHASE_EMAIL_PREVIEW: '/api/customer-journey/phase-email-templates/preview',
    CUSTOMER_JOURNEY_PHASE_EMAIL_TEST: '/api/customer-journey/phase-email-templates/test-send',
    CUSTOMER_JOURNEY_EMAIL_SEND_LOGS: '/api/customer-journey/email-send-logs',
    CUSTOMER_JOURNEY_IMPROVEMENT_PLANS: '/api/customer-journey/improvement-plans',
    CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_CREATE: '/api/customer-journey/improvement-plans',
    CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_UPDATE: '/api/customer-journey/improvement-plans/',
    CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_DELETE: '/api/customer-journey/improvement-plans/',
    CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_FOLLOWUPS: '/api/customer-journey/improvement-plans/',
    CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_FOLLOWUP_CREATE: '/api/customer-journey/improvement-plans/',
    CUSTOMER_JOURNEY_METRICS_SUMMARY: '/api/customer-journey/metrics/summary',
    CUSTOMER_JOURNEY_METRICS_BY_ID: '/api/customer-journey/',
    CUSTOMER_JOURNEY_SEARCH: '/api/customer-journey/search',
    CUSTOMER_JOURNEY_CXJ_ENCUESTAS: '/api/customer-journey/cxj/encuestas',
    CUSTOMER_JOURNEY_SURVEY_MARK_MANAGED: '/api/customer-journey/surveys/',
    CUSTOMER_JOURNEY_SURVEY_DELETE: '/api/customer-journey/surveys/',
    GEMINI_CHAT: '/api/gemini/chat',
    SERVICE_INFO_PROXY: '/api/client-proxy/service_types/service-info',
    CLIENT_PROXY_CUSTOMERS: '/api/client-proxy/customers/',
    // Administración de usuarios (backend Hoja; en nginx /api/users/ va al microservicio Clientes)
    USERS_ALL: '/api/hoja-servicios/users/',
    USER_BY_ID: '/api/hoja-servicios/users/',
    USER_UPDATE: '/api/hoja-servicios/users/',
    USER_CREATE: '/api/hoja-servicios/users/',
    USER_DEACTIVATE: '/api/hoja-servicios/users/',
    USER_ACTIVATE: '/api/hoja-servicios/users/',
    USER_RESET_PASSWORD: '/api/hoja-servicios/users/',
    USER_DELETE: '/api/hoja-servicios/users/',
    USER_MODULES: '/api/hoja-servicios/users/modules',
    USER_CLIENTS: '/api/hoja-servicios/users/clients',
    USER_CHANGE_PASSWORD: '/api/hoja-servicios/users/change-password',
    USER_LOGIN_LOGS: '/api/hoja-servicios/users/',
    USER_RECENT_LOGINS: '/api/recent-sessions',
    // Catálogos para Crear/Editar usuario (lista completa)
    CITIES_LIST: '/api/cities/',
    DEPARTMENTS_LIST: '/api/departments/',
    AREAS_LIST: '/api/areas/',
    SUB_AREAS_LIST: '/api/sub_areas/',
    POSITIONS_LIST: '/api/positions/',
    PROVINCES_LIST: '/api/provinces/',
    COUNTRIES_LIST: '/api/countries/',
    // CRUD Catálogos (Team / administración)
    CLIENTS_LIST: '/api/clients/',
    CLIENT_CREATE: '/api/clients/',
    CLIENT_UPDATE: '/api/clients/',
    CLIENT_DELETE: '/api/clients/',
    ROLES_LIST: '/api/roles/',
    ROLE_CREATE: '/api/roles/',
    ROLE_UPDATE: '/api/roles/',
    ROLE_DELETE: '/api/roles/',
    CITY_CREATE: '/api/cities/',
    CITY_UPDATE: '/api/cities/',
    CITY_DELETE: '/api/cities/',
    DEPARTMENT_CREATE: '/api/departments/',
    DEPARTMENT_UPDATE: '/api/departments/',
    DEPARTMENT_DELETE: '/api/departments/',
    AREA_CREATE: '/api/areas/',
    AREA_UPDATE: '/api/areas/',
    AREA_DELETE: '/api/areas/',
    SUB_AREA_CREATE: '/api/sub_areas/',
    SUB_AREA_UPDATE: '/api/sub_areas/',
    SUB_AREA_DELETE: '/api/sub_areas/',
    POSITION_CREATE: '/api/positions/',
    POSITION_UPDATE: '/api/positions/',
    POSITION_DELETE: '/api/positions/',
    /** Estados de tarea (task_status); list/create comparten base; update añade id en getApiUrl */
    TASK_STATUS_LIST: '/api/task_status/',
    TASK_STATUS_CREATE: '/api/task_status/',
    TASK_STATUS_UPDATE: '/api/task_status/'
  }
};

const HOJA_USER_ADMIN_PATH = '/api/hoja-servicios/users';
const HOJA_TICKETS_CATALOG_PREFIX = '/api/hoja-servicios/tickets';

function isDirectHojaBackendHost(hostname) {
  if (!hostname) return false;
  const h = String(hostname).toLowerCase();
  return h.endsWith('.run.app') || h === 'localhost' || h === '127.0.0.1';
}

/**
 * True si el front se sirve con nginx (prod, docker :8080).
 * False en CRA dev (:3000) → API directa al Flask en REACT_APP_API_BASE_URL.
 */
export function usesHojaNginxApiProxy() {
  if (typeof window === 'undefined') return true;
  const { hostname, port } = window.location;
  const h = String(hostname).toLowerCase();
  return !((h === 'localhost' || h === '127.0.0.1') && port === '3000');
}

function hojaTicketsApiBaseUrl() {
  const base = String(API_CONFIG.BASE_URL || 'http://localhost:5503').trim().replace(/\/$/, '');
  try {
    const origin = new URL(base.startsWith('http') ? base : `http://${base}`);
    return origin.origin;
  } catch (_) {
    return 'http://localhost:5503';
  }
}

/**
 * URL de administración LDAP (Team). En nginx del SPA usar /api/hoja-servicios/users;
 * en desarrollo CRA (:3000) usar /api/users del backend Flask directo.
 */
export function getHojaUserAdminUrl(subpath = '') {
  const extra = subpath
    ? (String(subpath).startsWith('/') ? String(subpath) : `/${subpath}`)
    : '/';
  const hojaPath = `${HOJA_USER_ADMIN_PATH}${extra}`;
  if (usesHojaNginxApiProxy()) {
    return hojaPath;
  }
  return `${hojaTicketsApiBaseUrl()}/api/users${extra}`;
}

/** PUT/PATCH/DELETE usuario Team: id y acción opcional (deactivate, reset-password, …). */
export function getHojaUserAdminUserUrl(userId, action = '') {
  const id = String(userId ?? '').trim();
  if (!id) return getHojaUserAdminUrl();
  const actionPart = action ? `/${String(action).replace(/^\//, '')}` : '';
  return getHojaUserAdminUrl(`/${id}${actionPart}`);
}

/**
 * Catálogos LDAP del backend tickets (cities, roles, …) sin colisión con microservicio Clientes.
 */
export function getHojaTicketsCatalogUrl(catalogPath) {
  const path = catalogPath
    ? (String(catalogPath).startsWith('/') ? String(catalogPath) : `/${catalogPath}`)
    : '/';
  if (usesHojaNginxApiProxy()) {
    return `${HOJA_TICKETS_CATALOG_PREFIX}${path}`;
  }
  return `${hojaTicketsApiBaseUrl()}/api${path}`;
}

/** Team y admin LDAP usan backend Hoja; en mismo origen nginx /api/users/ va al microservicio Clientes. */
export function resolveHojaUserAdminUrl(path) {
  if (!path || typeof path !== 'string' || !path.includes(HOJA_USER_ADMIN_PATH)) return path;
  if (usesHojaNginxApiProxy()) {
    const idx = path.indexOf(HOJA_USER_ADMIN_PATH);
    return idx >= 0 ? path.slice(idx) : path;
  }
  const base = String(API_CONFIG.BASE_URL || '').trim().replace(/\/$/, '');
  if (!base) {
    return path.split(HOJA_USER_ADMIN_PATH).join('/api/users');
  }
  try {
    const apiOrigin = new URL(
      base.startsWith('http') ? base : `${window.location.origin}${base.startsWith('/') ? '' : '/'}${base}`
    );
    const rewritten = path.split(HOJA_USER_ADMIN_PATH).join('/api/users');
    if (rewritten.startsWith('http')) return rewritten;
    return `${apiOrigin.origin}${rewritten.startsWith('/') ? rewritten : `/${rewritten}`}`;
  } catch (_) {
    return path.split(HOJA_USER_ADMIN_PATH).join('/api/users');
  }
}

const withHojaUsersUrl = (url) => resolveHojaUserAdminUrl(url);

/** Catálogos Team que en nginx no deben ir al microservicio Clientes (/api/cities, /api/roles, …). */
const HOJA_TICKETS_CATALOG_ENDPOINTS = {
  /** Soporte / Nueva Tarea / Reasignar (mismo catálogo que Team) */
  CITY: '/cities/',
  CITIES_LIST: '/cities/',
  CITY_CREATE: '/cities/',
  CITY_UPDATE: '/cities/',
  CITY_DELETE: '/cities/',
  DEPARTMENTS_LIST: '/departments/',
  DEPARTMENT_CREATE: '/departments/',
  DEPARTMENT_UPDATE: '/departments/',
  DEPARTMENT_DELETE: '/departments/',
  AREAS_LIST: '/areas/',
  AREA_CREATE: '/areas/',
  AREA_UPDATE: '/areas/',
  AREA_DELETE: '/areas/',
  SUB_AREAS_LIST: '/sub_areas/',
  SUB_AREA_CREATE: '/sub_areas/',
  SUB_AREA_UPDATE: '/sub_areas/',
  SUB_AREA_DELETE: '/sub_areas/',
  POSITIONS_LIST: '/positions/',
  POSITION_CREATE: '/positions/',
  POSITION_UPDATE: '/positions/',
  POSITION_DELETE: '/positions/',
  ROLES_LIST: '/roles/',
  ROLE_CREATE: '/roles/',
  ROLE_UPDATE: '/roles/',
  ROLE_DELETE: '/roles/',
};

/**
 * Rutas de asignación (ciudad → área → torre → usuario) del backend tickets.
 * En nginx, /api/cities y /api/users van a Clientes; hay que pasar por hoja-servicios/tickets.
 */
function tryHojaTicketsAssigneeCatalogUrl(endpointKey, params = []) {
  if (!usesHojaNginxApiProxy()) return null;
  if (endpointKey === 'AREAS_BY_CITY' && params[0] != null) {
    return getHojaTicketsCatalogUrl(`/areas/by-city/${params[0]}`);
  }
  if (endpointKey === 'USERS_BY_CITY_AREA' && params[0] != null && params[1] != null) {
    return getHojaTicketsCatalogUrl(`/users/by-city-area/${params[0]}/${params[1]}`);
  }
  if (endpointKey === 'SUB_AREAS_BY_CITY' && params[0] != null) {
    return getHojaTicketsCatalogUrl(`/sub_areas/by-city/${params[0]}`);
  }
  if (endpointKey === 'SUB_AREAS_BY_CITY_AREA' && params[0] != null && params[1] != null) {
    return getHojaTicketsCatalogUrl(`/sub_areas/by-city-area/${params[0]}/${params[1]}`);
  }
  if (endpointKey === 'USERS_BY_CITY_AREA_SUBAREA' && params[0] != null && params[1] != null && params[2] != null) {
    return getHojaTicketsCatalogUrl(`/users/by-city-area-subarea/${params[0]}/${params[1]}/${params[2]}`);
  }
  if (endpointKey === 'SUB_AREAS_FOR_ASSIGNEE_FILTER') {
    const queryParams = params[0] || {};
    const queryString = new URLSearchParams(queryParams).toString();
    const path = queryString
      ? `/sub_areas/for-assignee-filter?${queryString}`
      : '/sub_areas/for-assignee-filter';
    return getHojaTicketsCatalogUrl(path);
  }
  return null;
}

function tryHojaTicketsCatalogUrl(endpointKey, params = []) {
  if (!usesHojaNginxApiProxy()) return null;
  const assigneeUrl = tryHojaTicketsAssigneeCatalogUrl(endpointKey, params);
  if (assigneeUrl) return assigneeUrl;
  const basePath = HOJA_TICKETS_CATALOG_ENDPOINTS[endpointKey];
  if (!basePath) return null;
  const id = params[0] != null ? String(params[0]) : '';
  return getHojaTicketsCatalogUrl(`${basePath}${id}`);
}

export const getApiUrl = (endpointKey, ...params) => {
  if (endpointKey === '') {
    return API_CONFIG.BASE_URL;
  }
  
  if (typeof endpointKey === 'string' && endpointKey.startsWith('/')) {
    return `${API_CONFIG.BASE_URL}${endpointKey}`;
  }
  
  const endpoint = API_CONFIG.ENDPOINTS[endpointKey];
  if (!endpoint) {
    console.warn(`Endpoint no encontrado: ${endpointKey}`);
    return `${API_CONFIG.BASE_URL}${endpointKey}`;
  }

  const hojaCatalogUrl = tryHojaTicketsCatalogUrl(endpointKey, params);
  if (hojaCatalogUrl) return hojaCatalogUrl;

  const USER_ADMIN_ENDPOINTS = {
    USERS_ALL: () => getHojaUserAdminUrl(),
    USER_CREATE: () => getHojaUserAdminUrl(),
    USER_MODULES: () => getHojaUserAdminUrl('modules'),
    USER_CLIENTS: () => getHojaUserAdminUrl('clients'),
    USER_CHANGE_PASSWORD: () => getHojaUserAdminUrl('change-password'),
  };
  if (USER_ADMIN_ENDPOINTS[endpointKey]) {
    return USER_ADMIN_ENDPOINTS[endpointKey]();
  }
  
  if (params && params.length > 0) {
    if (endpointKey === 'TASK_BY_ID' || endpointKey === 'TASK_DETAIL') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'TASK_SUBTASKS' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/subtasks`;
    }
    if (endpointKey === 'TASK_PATCH_CONTRACT_SERVICE' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/contract-service`;
    }
    if (endpointKey === 'SERVICE_TICKET_PATCH_CONTRACT_NUMBER' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/contract-number`;
    }
    if (endpointKey === 'SERVICE_TICKET_PATCH_REQUESTED_SERVICE' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/requested-service`;
    }
    if (endpointKey === 'TASK_ATTENDANCE_REPORT') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/attendance-report`;
    }
    if (endpointKey === 'TASK_RESOLVE_HIERARCHY_REF') {
      return `${API_CONFIG.BASE_URL}${endpoint}${encodeURIComponent(String(params[0]))}`;
    }
    if (endpointKey === 'TASK_BY_ARRANDA') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'TASKS_ALL_BY_USER' || endpointKey === 'TASKS_BY_USER' || endpointKey === 'EMPLOYEE_TASKS') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'TASKS_BY_USER_TASKS') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/tasks`;
    }
    if (endpointKey === 'AREAS_BY_CITY') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'USERS_BY_CITY_AREA') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/${params[1]}`;
    }
    if (endpointKey === 'SUB_AREAS_BY_CITY') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'SUB_AREAS_FOR_ASSIGNEE_FILTER') {
      const queryParams = params[0] || {};
      const queryString = new URLSearchParams(queryParams).toString();
      return queryString
        ? `${API_CONFIG.BASE_URL}${endpoint}?${queryString}`
        : `${API_CONFIG.BASE_URL}${endpoint}`;
    }
    if (endpointKey === 'SUB_AREAS_BY_CITY_AREA') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/${params[1]}`;
    }
    if (endpointKey === 'USERS_BY_CITY_AREA_SUBAREA') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/${params[1]}/${params[2]}`;
    }
    if (endpointKey === 'TASK_FOLLOWUPS_BY_TASK' || endpointKey === 'TASK_FILES_BY_TASK') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'TASK_OBSERVATIONS_BY_TASK') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'TASK_OBSERVATION_BY_ID' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'TASK_OBSERVATION_MARK_READ' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/mark-read`;
    }
    if (endpointKey === 'TASK_OBSERVATIONS_MARK_ALL_READ' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/mark-all-read`;
    }
    if (endpointKey === 'TASKS_BY_CONTRACT_SERVICE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/service/${params[1]}`;
    }
    if (endpointKey === 'TASKS_BY_CLIENT_CONTRACT_FULL') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/contract/${params[1]}/full`;
    }
    if (endpointKey === 'TASKS_DATE_RANGE') {
      const queryParams = params[0] || {};
      const queryString = new URLSearchParams(queryParams).toString();
      return `${API_CONFIG.BASE_URL}${endpoint}?${queryString}`;
    }
    if (endpointKey === 'SERVICE_TICKETS_BALANCE_WORK_MINUTES') {
      const queryParams = params[0] || {};
      const queryString = new URLSearchParams(queryParams).toString();
      return queryString
        ? `${API_CONFIG.BASE_URL}${endpoint}?${queryString}`
        : `${API_CONFIG.BASE_URL}${endpoint}`;
    }
    if (endpointKey === 'TASKS_ATTENDANCE_REPORT_LIST') {
      const queryParams = params[0] || {};
      const queryString = new URLSearchParams(queryParams).toString();
      return `${API_CONFIG.BASE_URL}${endpoint}?${queryString}`;
    }
    if (endpointKey === 'SERVICE_TICKETS_FILTER') {
      const queryParams = params[0] || {};
      const queryString = new URLSearchParams(queryParams).toString();
      return queryString
        ? `${API_CONFIG.BASE_URL}${endpoint}?${queryString}`
        : `${API_CONFIG.BASE_URL}${endpoint}`;
    }
    if (endpointKey === 'TASKS_COMPLETED_BY_MONTH') {
      const months = params[0] != null ? String(params[0]) : '12';
      return `${API_CONFIG.BASE_URL}${endpoint}?months=${encodeURIComponent(months)}`;
    }
    if (endpointKey === 'SURVEY_QUESTIONS_BY_TASK') {
      const queryParams = params[0] || {};
      const queryString = new URLSearchParams(queryParams).toString();
      return `${API_CONFIG.BASE_URL}${endpoint}?${queryString}`;
    }
    if (endpointKey === 'SURVEY_RATINGS_BY_CLIENT_CONTRACT') {
      const q = new URLSearchParams({ empresa_id: params[0], contract_id: params[1] }).toString();
      return `${API_CONFIG.BASE_URL}${endpoint}?${q}`;
    }
    if (endpointKey === 'JOURNEY_EXPERIENCE_GESTIONADO' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/gestionado`;
    }
    if (endpointKey === 'JOURNEY_RESPONSE_PATCH' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}/${params[0]}`;
    }
    if (endpointKey === 'JOURNEY_RESPONSES' && params[0] != null) {
      const queryParams = params[0];
      const q = new URLSearchParams(queryParams).toString();
      return `${API_CONFIG.BASE_URL}${endpoint}?${q}`;
    }
    if (endpointKey === 'PUBLIC_SURVEY' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}/${params[0]}`;
    }
    if (endpointKey === 'SERVICE_INFO_PROXY' && params[0] != null && params[1] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}/${params[0]}/${params[1]}`;
    }
    // Customer Journey endpoints con parámetros
    if (endpointKey === 'CUSTOMER_JOURNEY_BY_ID' || endpointKey === 'CUSTOMER_JOURNEY_UPDATE' || endpointKey === 'CUSTOMER_JOURNEY_DELETE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_UPLOAD_FILES' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/upload-files`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_SIMULATE_PHASE_EMAILS' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/simulate-phase-emails`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_DELETE_FILE' && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/files`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_EVENTS' || endpointKey === 'CUSTOMER_JOURNEY_EVENT_CREATE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/events`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_SUPPORT_TASKS') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/support-tasks`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_MANUAL_FOLLOWUPS' || endpointKey === 'CUSTOMER_JOURNEY_MANUAL_FOLLOWUPS_CREATE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/manual-followups`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_SURVEYS' || endpointKey === 'CUSTOMER_JOURNEY_SURVEY_CREATE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/surveys`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_METRICS_BY_ID') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/metrics`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_SURVEY_MARK_MANAGED') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/managed`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_SURVEY_DELETE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_UPDATE' || endpointKey === 'CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_DELETE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_FOLLOWUPS' || endpointKey === 'CUSTOMER_JOURNEY_IMPROVEMENT_PLAN_FOLLOWUP_CREATE') {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}/followups`;
    }
    if (endpointKey === 'USER_BY_ID' || endpointKey === 'USER_UPDATE' || endpointKey === 'USER_DEACTIVATE' || endpointKey === 'USER_ACTIVATE' || endpointKey === 'USER_RESET_PASSWORD' || endpointKey === 'USER_DELETE') {
      const suffix = endpointKey === 'USER_DEACTIVATE' ? 'deactivate' : endpointKey === 'USER_ACTIVATE' ? 'activate' : endpointKey === 'USER_RESET_PASSWORD' ? 'reset-password' : '';
      return suffix ? getHojaUserAdminUserUrl(params[0], suffix) : getHojaUserAdminUserUrl(params[0]);
    }
    if (endpointKey === 'USER_LOGIN_LOGS') {
      return getHojaUserAdminUserUrl(params[0], 'login-logs');
    }
    // Catálogos CRUD con id
    const catalogIdKeys = ['CLIENT_UPDATE', 'CLIENT_DELETE', 'ROLE_UPDATE', 'ROLE_DELETE', 'CITY_UPDATE', 'CITY_DELETE', 'DEPARTMENT_UPDATE', 'DEPARTMENT_DELETE', 'AREA_UPDATE', 'AREA_DELETE', 'SUB_AREA_UPDATE', 'SUB_AREA_DELETE', 'POSITION_UPDATE', 'POSITION_DELETE', 'CRITICALITY_UPDATE', 'CRITICALITY_DELETE', 'REQUIREMENT_UPDATE', 'REQUIREMENT_DELETE', 'ARRANDA_INTERNAL_DETAILS_UPDATE', 'ARRANDA_INTERNAL_DETAILS_DELETE', 'TASK_STATUS_UPDATE'];
    if (catalogIdKeys.includes(endpointKey) && params[0] != null) {
      return `${API_CONFIG.BASE_URL}${endpoint}${params[0]}`;
    }
  }
  
  return withHojaUsersUrl(`${API_CONFIG.BASE_URL}${endpoint}`);
};

export const API_CONFIG_CLIENT = {
  BASE_URL: process.env.REACT_APP_CLIENT_API_BASE_URL,
  ENDPOINTS: {
    CUSTOMERSALL: '/api/customers/',
    CONTRACTS: '/client/contracts/overview/',
    SERVICES: '/client/contracts/',
    CREATE_TICKET: '/client/create_ticket',
    USER_PROFILE: '/client/user_profile',
    SERVICE_TYPES_SERVICE_INFO: '/client/service_types/service-info/',
    CUSTOMER_CONTACTS_BY_CUSTOMER: '/api/customer_contacts/customer/'
  }
};



export const getApiUrlClient = (endpointKey, ...params) => {
  if (typeof endpointKey === 'string' && endpointKey.startsWith('/')) {
    return `${API_CONFIG_CLIENT.BASE_URL}${endpointKey}`;
  }
  
  const endpoint = API_CONFIG_CLIENT.ENDPOINTS[endpointKey];
  if (!endpoint) {
    console.warn(`Endpoint no encontrado: ${endpointKey}`);
    return `${API_CONFIG_CLIENT.BASE_URL}${endpointKey}`;
  }
  
  if (params && params.length > 0) {
    if (endpointKey === 'CONTRACTS') {
      return `${API_CONFIG_CLIENT.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'SERVICES') {
      return `${API_CONFIG_CLIENT.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'SERVICE_TYPES_SERVICE_INFO') {
      if (params[0] === undefined || params[0] === null || params[1] === undefined || params[1] === null) {
        console.warn('SERVICE_TYPES_SERVICE_INFO requiere contract_id y serviceId válidos', { contract_id: params[0], serviceId: params[1] });
      }
      const contractId = String(params[0] || '');
      const serviceId = String(params[1] || '');
      return `${API_CONFIG_CLIENT.BASE_URL}${endpoint}${contractId}/${serviceId}`;
    }
    if (endpointKey === 'CUSTOMER_CONTACTS_BY_CUSTOMER') {
      return `${API_CONFIG_CLIENT.BASE_URL}${endpoint}${params[0]}`;
    }
    if (endpointKey === 'CUSTOMERSALL') {
      const queryParams = params[0] || {};
      const queryString = new URLSearchParams(queryParams).toString();
      return `${API_CONFIG_CLIENT.BASE_URL}${endpoint}?${queryString}`;
    }
  }
  
  return `${API_CONFIG_CLIENT.BASE_URL}${endpoint}`;
};

/**
 * Headers para llamadas al microservicio de clientes (Cloud Run).
 * Solo se usa el token para Bearer; el estado del usuario (módulos, permisos) se lee siempre del backend/BD.
 * Preferir proxy del backend (ej. SERVICE_INFO_PROXY) con credentials: 'include' cuando exista.
 */
export const getClientApiHeaders = (extra = {}) => {
  const token = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('auth_token')) || null;
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...extra
  };
};

export const API_CONFIG_SEARCH = {
  BASE_URL: process.env.REACT_APP_SEARCH_API_BASE_URL,
  ENDPOINTS: {
    SEARCH: '/search'
  }
};

export const getApiUrlSearch = (endpointKey) => {
  if (typeof endpointKey === 'string' && endpointKey.startsWith('/')) {
    return `${API_CONFIG_SEARCH.BASE_URL}${endpointKey}`;
  }
  
  const endpoint = API_CONFIG_SEARCH.ENDPOINTS[endpointKey];
  if (!endpoint) {
    console.warn(`Endpoint no encontrado: ${endpointKey}`);
    return `${API_CONFIG_SEARCH.BASE_URL}${endpointKey}`;
  }
  
  return `${API_CONFIG_SEARCH.BASE_URL}${endpoint}`;
};
